import { InjectionToken } from '@angular/core';

import type {
	ActivateUserUseCase,
	Add2FAMethodUseCase,
	ChangePasswordUseCase,
	CheckUserStatusUseCase,
	Delete2FAMethodUseCase,
	GenerateApiKeyUseCase,
	GenerateEmailOtpSecretUseCase,
	GenerateTotpSecretUseCase,
	GetUserTwoFactorMethodsType,
	LoginUseCase,
	LogoutUseCase,
	RecoveryPasswordUseCase,
	RefreshSessionUseCase,
	ResetPasswordUseCase,
	RevertSuplantUseCase,
	RevertUserActivationUseCase,
	SignupUseCase,
	SuplantUserByDeviceIdentificatorUseCase,
	SuplantUserUseCase,
	TwoFALoginUseCase,
	UnlockUserUseCase,
	Update2FAMethodUseCase,
	VerifyEmailOtpCodeUseCase,
	VerifyTotpCodeUseCase
} from '@contexts/auth/application';
import type { DeletePasskeyUseCase } from '@contexts/auth/application/use-cases/delete-passkey.usecase';
import type { FindAllPasskeysByUserIdUseCase } from '@contexts/auth/application/use-cases/find-all-passkeys-by-user-id.usecase';

export const LOGIN_USE_CASE = new InjectionToken<LoginUseCase>('LoginUseCase');
export const LOGOUT_USE_CASE = new InjectionToken<LogoutUseCase>('LogoutUseCase');
export const SIGNUP_USE_CASE = new InjectionToken<SignupUseCase>('SignupUseCase');
export const TWO_FA_LOGIN_USE_CASE = new InjectionToken<TwoFALoginUseCase>('TwoFALoginUseCase');
export const DELETE_2FA_METHOD_USE_CASE = new InjectionToken<Delete2FAMethodUseCase>(
	'Delete2FAMethodUseCase'
);
export const ADD_2FA_METHOD_USE_CASE = new InjectionToken<Add2FAMethodUseCase>(
	'Add2FAMethodUseCase'
);
export const ACTIVATE_USER_USE_CASE = new InjectionToken<ActivateUserUseCase>(
	'ActivateUserUseCase'
);
export const GENERATE_TOTP_SECRET_USE_CASE = new InjectionToken<GenerateTotpSecretUseCase>(
	'GenerateTotpSecretUseCase'
);
export const UPDATE_2FA_METHOD_USE_CASE = new InjectionToken<Update2FAMethodUseCase>(
	'Update2FAMethodUseCase'
);
export const VERIFY_TOTP_CODE_USE_CASE = new InjectionToken<VerifyTotpCodeUseCase>(
	'VerifyTotpCodeUseCase'
);

export const GENERATE_EMAIL_OTP_SECRET_USE_CASE = new InjectionToken<GenerateEmailOtpSecretUseCase>(
	'GenerateEmailOtpSecretUseCase'
);
export const VERIFY_EMAIL_OTP_CODE_USE_CASE = new InjectionToken<VerifyEmailOtpCodeUseCase>(
	'VerifyEmailOtpCodeUseCase'
);

export const CHANGE_PASSWORD_USE_CASE = new InjectionToken<ChangePasswordUseCase>(
	'ChangePasswordUseCase'
);
export const RECOVERY_PASSWORD_USE_CASE = new InjectionToken<RecoveryPasswordUseCase>(
	'RecoveryPasswordUseCase'
);
export const REFRESH_SESSION_USE_CASE = new InjectionToken<RefreshSessionUseCase>(
	'RefreshSessionUseCase'
);
export const RESET_PASSWORD_USE_CASE = new InjectionToken<ResetPasswordUseCase>(
	'ResetPasswordUseCase'
);
export const CHECK_USER_STATUS_USE_CASE = new InjectionToken<CheckUserStatusUseCase>(
	'CheckUserStatusUseCase'
);
export const REVERT_USER_ACTIVATION_USE_CASE = new InjectionToken<RevertUserActivationUseCase>(
	'RevertUserActivationUseCase'
);
export const UNLOCK_USER_USE_CASE = new InjectionToken<UnlockUserUseCase>('UnlockUserUseCase');
export const SUPLANT_USER_USE_CASE = new InjectionToken<SuplantUserUseCase>('SuplantUserUseCase');
export const SUPLANT_USER_BY_DEVICE_IDENTIFICATOR_USE_CASE =
	new InjectionToken<SuplantUserByDeviceIdentificatorUseCase>(
		'SuplantUserByDeviceIdentificatorUseCase'
	);
export const REVERT_SUPLANT_USE_CASE = new InjectionToken<RevertSuplantUseCase>(
	'RevertSuplantUseCase'
);
export const GET_USER_TWO_FACTOR_METHODS_USE_CASE = new InjectionToken<GetUserTwoFactorMethodsType>(
	'GetUserTwoFactorMethodsUseCase'
);
export const FIND_ALL_PASSKEYS_BY_USER_ID_USE_CASE =
	new InjectionToken<FindAllPasskeysByUserIdUseCase>('FindAllPasskeysByUserIdUseCase');
export const DELETE_PASSKEY_USE_CASE = new InjectionToken<DeletePasskeyUseCase>(
	'DeletePasskeyUseCase'
);
export const GENERATE_API_KEY_USE_CASE = new InjectionToken<GenerateApiKeyUseCase>(
	'GenerateApiKeyUseCase'
);
